/**
 * Shared computed props for form field accessibility (Phase 5).
 * Expects `name` and `field` props on the component.
 */
export default {
  computed: {
    fieldHasError() {
      return !!(this.field?.error_message);
    },
    fieldInvalidFeedbackId() {
      return `${this.name}invalid`;
    },
    fieldDescribedBy() {
      if (this.fieldHasError) {
        return this.fieldInvalidFeedbackId;
      }
      return undefined;
    },
    fieldAriaRequired() {
      return this.field?.required ? 'true' : undefined;
    },
    fieldAriaInvalid() {
      return this.fieldHasError ? 'true' : undefined;
    },
  },
};
